import { createContext, useContext, type ReactNode } from 'react';
interface UseApplicationCorrelationId {
  applicationCorrelationId: string;
  newApplication: boolean;
}

const ApplicationCorrelationIdContext =
  createContext<UseApplicationCorrelationId | null>(null);

export const useApplicationCorrelationId = () => {
  const context = useContext(ApplicationCorrelationIdContext);

  if (!context) {
    throw new Error('Missing correlation id');
  }
  return context;
};

export const ApplicationCorrelationIdProvider = ({
  applicationCorrelationId,
  isNewApplication,
  children,
}: {
  applicationCorrelationId: string;
  isNewApplication: boolean;
  children: ReactNode;
}) => (
  <ApplicationCorrelationIdContext.Provider
    value={{
      applicationCorrelationId,
      newApplication: isNewApplication,
    }}
  >
    {children}
  </ApplicationCorrelationIdContext.Provider>
);
